<!-- Enhanced Analysis Evidence and Recommendations -->
@if(evidenceSources.length > 0 || recommendations.length > 0){
<div class="enhanced-analysis-section">
  <!-- Evidence Sources -->
  @if(showEvidence && evidenceSources.length > 0){
  <div class="evidence-section">
    <h3 class="section-title">
      <mat-icon>source</mat-icon>
      {{ evidenceTitle }}
    </h3>
    <div class="evidence-grid">
      @for(evidence of evidenceSources; track evidence.url){
      <div class="evidence-card">
        <div class="evidence-header">
          <span class="evidence-category">{{ evidence.category }}</span>
          <span class="evidence-confidence">{{ (evidence.confidence_score * 100).toFixed(0) }}%
            confidence</span>
        </div>
        <div class="evidence-content">
          <p class="evidence-source">{{ evidence.source }}</p>
          <a [href]="evidence.url" target="_blank" class="evidence-link">
            <mat-icon>open_in_new</mat-icon>
            View Source
          </a>
        </div>
      </div>
      }
    </div>
  </div>
  }

  <!-- Recommendations -->
  @if(showRecommendations && recommendations.length > 0){
  <div class="recommendations-section">
    <h3 class="section-title">
      <mat-icon>lightbulb</mat-icon>
      {{ recommendationsTitle }}
    </h3>
    <div class="recommendations-grid">
      @for(rec of recommendations; track rec.category){
      <div class="recommendation-card" [class]="'priority-' + rec.priority.toLowerCase()">
        <div class="recommendation-header">
          <span class="recommendation-category">{{ rec.category }}</span>
          <span class="recommendation-priority" [class]="'priority-' + rec.priority.toLowerCase()">
            {{ rec.priority }}
          </span>
        </div>
        <div class="recommendation-content">
          <p class="recommendation-issue">{{ rec.issue }}</p>
          <p class="recommendation-text">{{ rec.recommendation }}</p>
          <div class="recommendation-impact">
            <mat-icon>trending_up</mat-icon>
            <span>{{ rec.expected_impact }}</span>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>
}
